import { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";

import { MDBRow, MDBCol } from "mdbreact";
import {
	useMaterialReactTable,
	MaterialReactTable,
	MRT_ToggleGlobalFilterButton,
	MRT_ToggleFiltersButton,
} from "material-react-table";

import {
	Input,
	Label,
	RadioInput,
	CheckboxInput,
	Button,
} from "abs-ui-components";

import BreadCrumb from "../../../common/breadCrumb/BreadCrumb";
import userAvatar from "../../../images/img_avatar1.png";
import {
	MEMBERSHIP,
	WCN,
	USER_DESCRIPTION,
	USER_INFO,
	MEMBERSHIP_HEADING,
} from "./Admin_constants.js";
import { emitToasterMsg } from "../../../services/toasterUtility.js";
import {
	changePassword,
	getRolesInfo,
	getUserWCNsDetails,
	updateOrganization,
	updateUserRoles,
	updateWCNForUser,
} from "../../../services/AdminService.js";

import { useNavigate } from "react-router-dom";
import { CircularProgress, IconButton } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";

// Reusable Input component
const AdminInput = ({
	name,
	control,
	defaultValue,
	rules,
	placeholder,
	type,
	errors,
	setError,
	clearErrors,
}) => {
	// Define a validation function

	const validateField = (value) => {
		// You can add more validation rules here
		if (rules?.required && !value) {
			setError(name, {
				type: "manual",
				message: rules.required,
			});
		} else {
			clearErrors(name);
		}
	};

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultValue}
			rules={rules}
			render={({ field }) => (
				<div className="mt-2">
					<Input
						required
						id={name}
						onChange={(e) => {
							field.onChange(e);
							validateField(e);
						}}
						type={type}
						value={field.value}
						autoFocus={false}
						className="input-details"
						placeholder={placeholder}
					/>
					{errors[name] && (
						<p className="error mt-1">{errors[name].message}</p>
					)}
				</div>
			)}
		/>
	);
};

const ManageUserDetails = () => {
	let userDetailsInfo;
	let officeLocation;
	let organization;
	if (sessionStorage?.userDetails) {
		userDetailsInfo = JSON.parse(sessionStorage?.userDetails);
		officeLocation = userDetailsInfo?.officeLocation;
		organization = userDetailsInfo?.organization;
	}

	const [selectAll, setSelectAll] = useState(false);
	const {
		control: controlPassword,
		getValues: getValuesPassword,
		handleSubmit: handlePasswordSubmit,
		setError: setErrorPassword,
		clearErrors: clearErrorsPassword,
		formState: { errors: passwordErrors },
	} = useForm();

	// Profile form
	const {
		control: controlProfile,
		getValues: getValuesProfile,
		handleSubmit: handleProfileSubmit,
		setError: setErrorProfile,
		clearErrors: clearErrorsProfile,
		formState: { errors: profileErrors },
	} = useForm();

	const { handleSubmit: handleRoleSubmit } = useForm();
	const [rolesInfoData, setRolesInfoData] = useState([]);
	let [checkboxData, setCheckboxData] = useState([]);
	const [wcnsInfoData, setWcnsInfoData] = useState([]);
	const [WCNSearchValue, setWCNSearchValue] = useState("");
	const [selected, setSelected] = useState(userDetailsInfo?.roles);
	const [WCNRowSelection, setWCNRowSelection] = useState([]);
	const [wcnPagination, setWcnPagination] = useState({
		pageIndex: 0,
		pageSize: 25,
	});
	const [loader, setLoader] = useState(true);
	const [rowCount, setRowCount] = useState(0);
	const [wcnColumnFilters, setWcnColumnFilters] = useState([]);
	const [loading, setLoading] = useState(true);
	const [previousGlobalFilter, setPreviousGlobalFilter] = useState("");
	const [wcnSort, setWcnSort] = useState([]);
	const [pendingWcnColumnFilters, setPendingWcnColumnFilters] = useState([]);
	const [searchInput, setSearchInput] = useState("");

	const navigate = useNavigate();

	useEffect(() => {
		checkRoleBased();
		getRolesDetails();
		fetchWcnDetails(
			WCNSearchValue,
			wcnPagination.pageIndex,
			wcnPagination.pageSize,
			wcnSort.length > 0 ? wcnSort[0] : wcnSort
		);
	}, [WCNSearchValue]);

	useEffect(() => {
		if (WCNSearchValue !== "" && previousGlobalFilter !== WCNSearchValue) {
			setPreviousGlobalFilter(WCNSearchValue);
			setWcnPagination({ ...wcnPagination, pageIndex: 0 });
			fetchWcnDetails(WCNSearchValue, 0, wcnPagination.pageSize);
		} else {
			fetchWcnDetails(
				WCNSearchValue,
				wcnPagination.pageIndex,
				wcnPagination.pageSize,
				wcnSort.length > 0 ? wcnSort[0] : wcnSort
			);
		}
	}, [
		WCNSearchValue,
		wcnColumnFilters,
		wcnPagination.pageIndex,
		wcnPagination.pageSize,
		wcnSort,
	]);

	const fetchWcnDetails = async (
		searchStr = "",
		pageIndex = 0,
		pageSize = 25,
		sortOption = {
			sortField: "",
			isAscending: false,
		}
	) => {
		const columnFilterPayload = wcnColumnFilters?.map((element) => {
			return {
				key: element.id,
				value: element.value,
			};
		});

		let requestPayload = {
			globalFilter: searchStr,
			filters: columnFilterPayload,
			pagination: {
				page: pageIndex + 1,
				pageSize: pageSize,
			},
			sortOption: {
				sortField: sortOption.id,
				isAscending: !sortOption.desc,
			},
		};
		try {
			setLoading(true);
			const response = await getUserWCNsDetails(
				requestPayload,
				userDetailsInfo?.userName
			);
			if (response) {
				const reponseData = response?.Data;
				setRowCount(response?.Pagination?.TotalItems);
				const defaultSelectedRowIds = reponseData
					.filter((row) =>
						userDetailsInfo["wcnMstIds"]?.includes(row.WcnMstId)
					)
					.map((item) => item.WcnMstId);
				setWCNRowSelection([
					...WCNRowSelection,
					...defaultSelectedRowIds,
				]);
				const selectedRows = reponseData.filter((row) =>
					defaultSelectedRowIds.includes(row.WcnMstId)
				);
				const unselectedRows = reponseData.filter(
					(row) => !defaultSelectedRowIds.includes(row.WcnMstId)
				);
				setWcnsInfoData([...selectedRows, ...unselectedRows]);
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};

	const getRolesDetails = async () => {
		setLoader(true);
		try {
			const response = await getRolesInfo();
			if (response && response?.isSuccess) {
				transformRolesData(response?.data?.roles);
				checkRoleBased(response?.data?.roles, userDetailsInfo?.roles);
				setLoader(false);
			}
		} catch (error) {
			setLoader(false);
			console.error(error);
		}
	};

	const checkRoleBased = (roleBased, infoRoles) => {
		let checkRoles = [];
		roleBased?.forEach((elements) => {
			infoRoles?.forEach((roleInfo) => {
				if (elements.normalizedName === roleInfo.toUpperCase()) {
					checkRoles.push(elements.normalizedName);
				}
			});
		});
		setCheckboxData(checkRoles);
	};

	const handleOrganizationDetails = async () => {
		const values = getValuesProfile();
		const { Organization, officeLocation } = values;
		const profileErrors = {};

		if (!Organization) {
			profileErrors.Organization = "Organization is required";
		}

		if (!officeLocation) {
			profileErrors.officeLocation = "Office Location is required";
		}
		if (Object.keys(profileErrors).length > 0) {
			Object.keys(profileErrors).forEach((field) => {
				setErrorProfile(field, {
					type: "manual",
					message: profileErrors[field],
				});
			});
			return;
		}
		// Clear all errors if no validation issues
		clearErrorsProfile();

		const requestPayload = {
			UserName: userDetailsInfo?.userName,
			officeLocation: officeLocation,
			organization: Organization,
		};
		try {
			const response = await updateOrganization(requestPayload);
			if (response && response?.isSuccess) {
				emitToasterMsg("success", "Organization updated successfully!");
				navigate("/admin");
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleUpdateDetails = async () => {
		const values = getValuesPassword();
		const { newPassword, confirmNewPassword } = values;
		const passwordErrors = {};

		// Validate new password
		if (!newPassword) {
			passwordErrors.newPassword = "New Password is required";
		}

		// Validate confirm new password
		if (!confirmNewPassword) {
			passwordErrors.confirmNewPassword = "Confirm Password is required";
		} else if (newPassword !== confirmNewPassword) {
			passwordErrors.confirmNewPassword = "Passwords do not match";
		}

		if (Object.keys(passwordErrors).length > 0) {
			Object.keys(passwordErrors).forEach((field) => {
				setErrorPassword(field, {
					type: "manual",
					message: passwordErrors[field],
				});
			});
			return;
		}

		clearErrorsPassword();

		const requestPayload = {
			UserName: userDetailsInfo?.userName,
			newPassword: newPassword,
			cf: confirmNewPassword,
		};

		try {
			const response = await changePassword(requestPayload);
			if (response && response?.isSuccess) {
				emitToasterMsg("success", "Password changed successfully!");
			} else {
				emitToasterMsg("error", response.errorMessage);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const transformRolesData = (roles) => {
		let rolesData = [];
		roles.forEach((element) => {
			rolesData.push(element.normalizedName);
		});
		setRolesInfoData(rolesData);
	};

	const WCNColumns = useMemo(
		() => [
			{
				header: "WCN",
				enableHiding: false,
				accessorKey: "WcnNumber",
			},
			{
				header: "Company Name",
				accessorKey: "CompanyName",
			},
			{
				header: "Combined Risk",
				accessorKey: "CombinedRiskId",
				accessorFn: (row) => {
					if (row.CombinedRiskId) {
						if (row.CombinedRiskId == "1") {
							return "Low";
						}
						if (row.CombinedRiskId == "2") {
							return "Medium";
						}
						if (row.CombinedRiskId == "3") {
							return "High";
						}
					}
				},
				enableColumnFilter: false,
			},
		],
		[]
	);

	const handleSelectAll = (event, field) => {
		setSelectAll(event.target?.checked);
	};

	const applyFilters = useCallback(() => {

		setWcnPagination((prev) => ({
			...prev,
			pageIndex: 0,
		}));

		setWcnColumnFilters([
			...pendingWcnColumnFilters,
		]);

		setWCNSearchValue(searchInput.trim());

	}, [pendingWcnColumnFilters, searchInput]);

	const resetFilterForColumn = useCallback((columnId) => {

		setWcnPagination((prev) => ({
			...prev,
			pageIndex: 0,
		}));

		setWcnColumnFilters((prev) =>
			prev.filter((f) => f.id !== columnId)
		);

	}, []);

	const handleColumnFiltersChange = useCallback(
		(updater) => {

			setPendingWcnColumnFilters((prev) => {

				const updated =
					typeof updater === "function"
						? updater(prev)
						: updater;

				// detect removed filters
				prev.forEach((oldFilter) => {

					const stillExists = updated.some(
						(newFilter) =>
							newFilter.id === oldFilter.id
					);

					if (!stillExists) {

						// ONLY if previously applied
						const wasApplied =
							wcnColumnFilters.some(
								(f) => f.id === oldFilter.id
							);

						if (wasApplied) {
							resetFilterForColumn(oldFilter.id);
						}
					}
				});

				return updated;
			});
		},
		[wcnColumnFilters, resetFilterForColumn]
	);

	const updateFilterValue = useCallback(
		(columnId, value) => {

			setPendingWcnColumnFilters((prev) => {

				const normalizedValue =
					value?.trim?.() ?? "";

				const others = prev.filter(
					(f) => f.id !== columnId
				);

				const updatedPending = normalizedValue
					? [
						...others,
						{
							id: columnId,
							value: normalizedValue,
						},
					]
					: others;

				// ONLY auto reset if filter was already applied
				const wasApplied =
					wcnColumnFilters.some(
						(f) => f.id === columnId
					);

				if (!normalizedValue && wasApplied) {

					setWcnPagination((prev) => ({
						...prev,
						pageIndex: 0,
					}));

					setWcnColumnFilters((prevApplied) =>
						prevApplied.filter(
							(f) => f.id !== columnId
						)
					);
				}

				return updatedPending;
			});
		},
		[wcnColumnFilters]
	);

	const clearAllFilters = useCallback(() => {

		setPendingWcnColumnFilters([]);

		setWcnColumnFilters([]);

		setSearchInput("");

		setWCNSearchValue("");

		setWcnPagination((prev) => ({
			...prev,
			pageIndex: 0,
		}));

	}, []);

	const userDetailsTable = useMaterialReactTable({
		columns: [
			...WCNColumns,
			{
				header: "Select WCN",
				accessorKey: "WcnMstId",
				enableSorting: false,
				enableColumnFilter: false,
				enableColumnActions: false,
				size: 200,
				Cell: ({ row: { original } }) => {
					const [selected, setSelected] = useState(
						WCNRowSelection?.includes(original.WcnMstId)
					);
					const handleSelectedWcn = (WcnMstId, event) => {
						setSelected(event);
						let filteredWcnList = WCNRowSelection;
						if (
							WCNRowSelection.length > 0 &&
							WCNRowSelection?.includes(WcnMstId)
						) {
							filteredWcnList = WCNRowSelection?.filter(
								(item) => item !== WcnMstId
							);
						} else filteredWcnList.push(WcnMstId);
						setWCNRowSelection(filteredWcnList);
					};

					return (
						<CheckboxInput
							checked={selected}
							onChange={(e) =>
								handleSelectedWcn(original.WcnMstId, e)
							}
						/>
					);
				},
			},
		],
		data: wcnsInfoData,
		manualSorting: false,
		enableStickyHeader: true,
		manualPagination: true,
		manualFiltering: true,
		enableRowActions: false,
		enableFullScreenToggle: false,
		enableDensityToggle: false,
		enableHiding: false,
		// enableToolbarInternalActions: false,
		// enableColumnActions: false,
		rowCount,
		getRowId: (row) => row.WcnMstId,
		// onGlobalFilterChange: setWCNSearchValue,
		onColumnFiltersChange: handleColumnFiltersChange,
		onPaginationChange: setWcnPagination,
		onSortingChange: setWcnSort,
		state: {
			globalFilter: searchInput,
			pagination: wcnPagination,
			columnFilters: pendingWcnColumnFilters,
			isLoading: loading,
			sorting: wcnSort,
		},
		displayColumnDefOptions: {
			"mrt-row-actions": {
				header: "",
			},
		},

		initialState: {
			density: "compact",
			columnOrder: [
				"WcnNumber",
				"CompanyName",
				"CombinedRiskId",
				"WcnMstId",
			],
		},
		muiPaginationProps: {
			rowsPerPageOptions: [25, 50, 75, 100],
			showFirstButton: true,
			showLastButton: true,
		},

		muiTableContainerProps: {
			sx: {
				maxHeight: "calc(100vh - 376px)",
			},
		},

		muiTableHeadCellProps: ({ column }) => ({
			id: `${column.columnDef.accessorKey}`,
			sx: {
				color: "rgb(255 255 255)",

				"& .MuiButtonBase-root": {
					color: "white !important",
					"& .MuiTableSortLabel-icon": {
						color: "white !important",
					},
				},
			},
		}),
		muiFilterTextFieldProps: ({ column }) => ({
			sx: {
				"& .MuiInput-root": {
					color: "white !important",
				},
				"& .MuiButtonBase-root": {
					color: "white !important",
				},
				"& .MuiInputBase-root::after": {
					transform: "none",
					borderBottom: "2px solid white",
				},
				"& .MuiSvgIcon-root": {
					color: "white",
				},
			},
			onChange: (e) => {

				const value = e.target.value;

				updateFilterValue(column.id, value);
			},
			onKeyDown: (e) => {
				if (e.key === "Enter") {
					applyFilters();
				}
			},
		}),
		muiColumnActionsButtonProps: {
			sx: {
				color: "white",
			},
		},
		muiTableBodyRowProps: ({ row }) => ({
			sx: {
				cursor: "pointer",
			},
		}),
		muiSelectAllCheckboxProps: {
			title: selectAll ? "Toggle deselect all" : "Toggle select all.....",
			id: "test1",
			onClick: (e, field) => handleSelectAll(e, field),
			sx: {
				color: "white",
			},
		},
		muiTableHeadRowProps: {
			sx: {
				backgroundColor: "#042a4c !important",

				"& .MuiTableCell-head::before": {
					backgroundColor: "#042a4c !important",
				},
			},
		},
		muiTablePaperProps: {
			sx: {
				boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)",
			},
		},
		muiSearchTextFieldProps: {
			placeholder: `Type and Enter`,
			// sx: { minWidth: "400px" },
			value: searchInput, // controlled by local state
			onChange: (e) => {
				const rawValue = e.target.value;
				setSearchInput(rawValue); // only updates local input, no API call
			},
			onKeyDown: (e) => {
				if (e.key === "Enter") {
					applyFilters();
				}
			},
			InputProps: {
				endAdornment: searchInput && (
					<IconButton
						size="small"
						onClick={() => {
							setSearchInput("");
							setWCNSearchValue("");
							setWcnPagination((prev) => ({ ...prev, pageIndex: 0 }));
						}}
						sx={{ visibility: searchInput ? "visible" : "hidden" }}
					>
						<ClearIcon fontSize="small" />
					</IconButton>
				),
			},
		},
		renderToolbarInternalActions: ({ table }) => (
			<>
				<MRT_ToggleGlobalFilterButton
					id="pc_view_global_search"
					table={table}
				/>
				<MRT_ToggleFiltersButton
					id="pc_view_global_filter"
					table={table}
				/>
				<Button
					className="ml-2"
					onClick={() => {
						applyFilters();
					}}
				>
					Apply Filters
				</Button>
				<Button
					className="ml-2"
					variant="secondary"
					onClick={clearAllFilters}
				>
					Clear
				</Button>
			</>
		),
	});

	const breadcrumb = useMemo(
		() => [
			{
				label: "Manage Users",
				url: "/admin",
				navId: "admin_navId",
			},
			{
				label: "User Details",
				url: "",
				navId: "admindetails_navId",
			},
		],
		[]
	);

	const handleCheckboxChange = (role) => {
		let selectedRole = [];
		selectedRole.push(role);
		setSelected(selectedRole);
		setCheckboxData(role);
	};

	const handleAssignRole = async () => {
		const requestPayload = {
			id: userDetailsInfo.id,
			roles: selected,
		};
		try {
			const response = await updateUserRoles(requestPayload);
			if (response && response?.isSuccess) {
				emitToasterMsg("success", "Role(s) assigned successfully!");
			}
			navigate("/admin");
		} catch (error) {
			console.error(error);
		}
	};

	const updateUserWCN = async () => {
		const assignedWcns = WCNRowSelection.filter(
			(val, index) => WCNRowSelection.indexOf(val) === index
		);
		const userWCNObj = {
			userName: userDetailsInfo.email,
			wcnMstIds: assignedWcns,
		};
		try {
			const response = await updateWCNForUser(userWCNObj);
			if (response && response?.isSuccess) {
				emitToasterMsg("success", "WCN", "Updated Successfully!");
			}
			navigate("/admin");
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<>
			<div className="actions-top pl-4 mt-3">
				<BreadCrumb items={breadcrumb} />
			</div>

			<MDBRow>
				<MDBCol className="col-6 user-info">
					<div className="d-flex ml-5 mt-3">
						<p className="user-details">
							{" "}
							{USER_DESCRIPTION.USER_DETAILS}
						</p>
						<p className="user-note ml-5">
							{USER_DESCRIPTION.NOTE}
						</p>
					</div>
					<MDBRow className="mt-3 ml-4">
						{/* <MDBCol md="1" /> */}
						<MDBCol md="1">
							<img
								src={userAvatar}
								alt="user Avatar"
								className="user-Avatar"
							/>
						</MDBCol>
						<MDBCol className="ml-4">
							<div className="ml-5">
								<div className="d-flex">
									<p className="user-info-key">
										{USER_INFO.NAME}{" "}
									</p>
									<p className="user-details ml-2">
										: {userDetailsInfo?.firstName}{" "}
										{userDetailsInfo?.lastName}
									</p>
								</div>
								<div className="d-flex">
									<p className="user-info-key">
										{USER_INFO?.EMAIL}{" "}
									</p>
									<p className="user-details ml-5">
										: {userDetailsInfo?.email}
									</p>
								</div>
							</div>
						</MDBCol>
					</MDBRow>

					<form
						onSubmit={handleProfileSubmit(
							handleOrganizationDetails
						)}
					>
						<MDBRow className="mt-3 ml-2">
							<MDBCol
								md="4"
								className="Organization-details p-4 ml-2"
							>
								<Label
									bold
									required
									name="Organization"
									className="mb-1"
								/>
								<AdminInput
									name="Organization"
									control={controlProfile}
									defaultValue={organization}
									placeholder="Organization"
									rules={{
										required: "Organization is required",
									}}
									errors={profileErrors}
									type="text"
									setError={setErrorProfile}
									clearErrors={clearErrorsProfile}
								/>
							</MDBCol>
							<MDBCol md="4">
								<Label
									bold
									required
									name="Office Location"
									className="mt-4"
								/>
								<AdminInput
									name="officeLocation"
									control={controlProfile}
									errors={profileErrors}
									rules={{
										required: "office Location is required",
									}}
									defaultValue={officeLocation}
									placeholder="Location"
									type="text"
									setError={setErrorProfile}
									clearErrors={clearErrorsProfile}
								/>
							</MDBCol>
							<MDBCol md="3 ml-2">
								<Button
									className="Update text-center mt-5"
									onClick={handleOrganizationDetails}
								>
									Update
								</Button>
							</MDBCol>
						</MDBRow>
					</form>

					<form onSubmit={handlePasswordSubmit(handleUpdateDetails)}>
						<MDBRow className="ml-2">
							<MDBCol
								md="4"
								className="Organization-details p-4 ml-2"
							>
								<Label
									bold
									required
									name="New Password"
									className="mb-1"
								/>
								<AdminInput
									name="newPassword"
									control={controlPassword}
									errors={passwordErrors}
									defaultValue=""
									rules={{ required: "Password is required" }}
									placeholder="New Password"
									type="password"
									setError={setErrorPassword}
									clearErrors={clearErrorsPassword}
								/>
							</MDBCol>
							<MDBCol md="4">
								<Label
									bold
									required
									name="Confirm New Password"
									className="mt-4"
								/>
								<AdminInput
									name="confirmNewPassword"
									control={controlPassword}
									setError={setErrorPassword}
									clearErrors={clearErrorsPassword}
									errors={passwordErrors}
									defaultValue=""
									rules={{
										required:
											"Confirm Password is required",
										validate: (value) =>
											value ===
												getValuesPassword(
													"newPassword"
												) || "Passwords do not match",
									}}
									placeholder="Confirm New Password"
									type="password"
								/>
							</MDBCol>
							<MDBCol className="col-3">
								<div className="d-flex">
									<Button
										className="change-password text-center mt-5"
										onClick={handleUpdateDetails}
									>
										Change Password
									</Button>
								</div>
							</MDBCol>
						</MDBRow>
					</form>
				</MDBCol>

				<MDBCol className="col-6 roles-info">
					<MDBRow className="mt-3">
						<MDBCol md="1" />
						<MDBCol>
							<h6 bold className="membership-heading">
								{" "}
								{MEMBERSHIP_HEADING.TITLE}
							</h6>
							<ul className="membership-container mt-4">
								<li>
									{MEMBERSHIP.INFO +
										`${userDetailsInfo?.email} to that role `}
								</li>
								<li>
									{MEMBERSHIP.INFO_1 +
										`${userDetailsInfo?.email} to that role `}
								</li>
								<li>{MEMBERSHIP.INFO_2}</li>
							</ul>
						</MDBCol>
					</MDBRow>

					<form onSubmit={handleRoleSubmit(handleAssignRole)}>
						<div className="table-container">
							<div className="table-role">
								<div className="">
									{loader ? (
										<div className="d-flex justify-content-center align-items-center circular-loader">
											<CircularProgress size={25} />
										</div>
									) : (
										<>
											<div className="row roles-radio-container">
												{rolesInfoData.map(
													(roleItem, index) => (
														<div
															key={index}
															className="col-lg-4 col-md-6 col-sm-6 mt-1"
														>
															{roleItem && (
																<div>
																	<RadioInput
																		label={
																			roleItem
																		}
																		gap="true"
																		checked={checkboxData.includes(
																			roleItem
																		)}
																		onChange={() => {
																			handleCheckboxChange(
																				roleItem
																			);
																		}}
																	/>
																</div>
															)}
														</div>
													)
												)}
											</div>
										</>
									)}
								</div>
								<div className="d-flex save-changes-btn justify-content-end ">
									<Button
										type="submit"
										className=" text-center mt-4 p-2"
										onClick={handleAssignRole}
									>
										{" "}
										Save changes
									</Button>
								</div>
							</div>
						</div>
					</form>
				</MDBCol>
			</MDBRow>

			{userDetailsInfo?.roles.includes("ER_CLIENT") ||
			userDetailsInfo?.roles.includes("ER_USER") ? (
				<div className="p-3">
					<h6 className="WCN-management">{WCN.WCN_MAP}</h6>
					<h6 className="WCN-management">
						{WCN.WCN_SELECT + userDetailsInfo.email}
					</h6>
					<div className="mt-3 wcn-table-container">
						<MaterialReactTable
							table={userDetailsTable}
							className="mt-4"
						/>
					</div>

					<div className="d-flex justify-content-end ">
						<Button
							type="submit"
							className=" text-center mt-4 p-2"
							onClick={updateUserWCN}
						>
							{" "}
							Save changes
						</Button>
					</div>
				</div>
			) : (
				<div className="mt-5 p-3">
					<div class="card ">
						<div class="card-body">
							<div class="row col-lg-12">
								All WCNs are assigned to this user.
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ManageUserDetails;
